import { logger } from './logger';
import { sleep } from './time';

export function serializeFormDataToJSON(formdata) {
  try {
    return Array.from(formdata.entries()).reduce((data, [field, value]) => {
      let [_, prefix, keys] = field.match(/^([^\[]+)((?:\[[^\]]*\])*)/);

      if (keys) {
        keys = Array.from(keys.matchAll(/\[([^\]]*)\]/g), m => m[1]);
        value = update(data[prefix], keys, value);
      }
      data[prefix] = value;
      return data;
    }, {});
  } catch (e) {
    logger.log('error in serialize', e);
    return {};
  }
}

function update(data, keys, value) {
  if (keys.length === 0) {
    // Leaf node
    return value;
  }

  let key = keys.shift();
  if (!key) {
    data = data || [];
    if (Array.isArray(data)) {
      key = data.length;
    }
  }

  // removing this as properties was treated as an array

  // Try converting key to a numeric value
  // let index = +key;
  // if (!isNaN(index)) {
  // We have a numeric index, make data a numeric array
  // This will not work if this is a associative array
  // with numeric keys
  //   data = data || [];
  //   key = index;
  // }

  // If none of the above matched, we have an associative array
  data = data || {};

  let val = update(data[key], keys, value);
  data[key.toString()] = val;
  // data[key] = val;

  return data;
}

export function serializeFormToJSON(form) {
  try {
    return Array.from(new FormData(form).entries()).reduce(
      (data, [field, value]) => {
        let [_, prefix, keys] = field.match(/^([^\[]+)((?:\[[^\]]*\])*)/);

        if (keys) {
          keys = Array.from(keys.matchAll(/\[([^\]]*)\]/g), m => m[1]);
          value = update(data[prefix], keys, value);
        }
        data[prefix] = value;
        return data;
      },
      {},
    );
  } catch (e) {
    logger.log('error in parsing form', e);
    return {};
  }
}

export function createEmebeddedContainer({ id, selector, position }) {
  const element = document.getElementById(id);
  if (element) {
    logger.log('element found', element);
    return true;
  }

  if (!selector) {
    return false;
  }

  // get the reference node by selector
  let referenceNode = document.querySelector(selector);
  if (!referenceNode) {
    return false;
  }

  // fallback for reference node height 0
  if (referenceNode.offsetHeight <= 0) {
    referenceNode = null;
    const nodes = document.querySelectorAll(selector);
    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];
      if (node.offsetHeight > 0) {
        referenceNode = node;
        break;
      }
    }
  }

  if (!referenceNode) {
    return false;
  }

  const elem = document.createElement('div');
  elem.setAttribute('id', id);
  if (position === 'before') {
    createElementBefore(referenceNode, elem);
  } else {
    createElementAfter(referenceNode, elem);
  }
  return true;
}

export async function createEmebeddedContainerWrapper({
  id,
  selector,
  position,
  retryContainerCreation,
}) {
  if (!selector) {
    return false;
  }
  const counter = retryContainerCreation ? 10 : 1;
  for (let i = 0; i < counter; i += 1) {
    const created = createEmebeddedContainer({ id, selector, position });
    if (created) {
      logger.log('created', selector, id);
      return true;
    }
    await sleep(200);
  }
  logger.log('referenceNode not found', selector, id);
  return false;
}

export function createElementAfter(element, newElement) {
  element.parentNode.insertBefore(newElement, element.nextSibling);
}

export function createElementBefore(element, newElement) {
  element.parentNode.insertBefore(newElement, element);
}

var mr_atc_internal = false;
var mr_c_internal = false;
var mr_bn_internal = false;
var clickingCheckout = false;
var clickingAtc = false;

export function getmr_atc_internal() {
  return mr_atc_internal;
}
export function getmr_c_internal() {
  return mr_c_internal;
}
export function getmr_bn_internal() {
  return mr_bn_internal;
}
export function getclickingCheckout() {
  return clickingCheckout;
}

export function getclickingATC() {
  return clickingAtc;
}

export function setmr_atc_internal(val) {
  mr_atc_internal = val;
}
export function setmr_c_internal(val) {
  mr_c_internal = val;
}
export function setmr_bn_internal(val) {
  mr_bn_internal = val;
}
export function setclickingCheckout(val) {
  clickingCheckout = val;
}

export function setclickingATC(val) {
  clickingAtc = val;
}

export function continueEvent(event, t) {
  logger.log('continueEvent', event, t);
  if (t === 'atc') {
    mr_atc_internal = true;
  }
  if (t === 'c') {
    clickingCheckout = false;
    mr_c_internal = true;
  }
  if (t === 'bn') {
    mr_bn_internal = true;
  }

  handleElementClick(event.target);
}

export function handleElementClick(targetElement) {
  if (targetElement.click === undefined) {
    handleElementClick(targetElement.parentElement);
  } else {
    targetElement.click();
  }
}

export const getWidthBasedOnShop = (shop, defaultWidth) => {
  let shopSpecificWidth = defaultWidth;
  switch (shop) {
    case 'sneaker-dog.myshopify.com':
      shopSpecificWidth = 320;
      break;

    case 'jolies-culottes.myshopify.com':
      shopSpecificWidth = 480;
      break;

    default:
      break;
  }
  return shopSpecificWidth;
};
